import React from 'react';

import { GroupOrderBagButton } from '../GroupOrderBagButton/GroupOrderBagButton';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderBagUnlockButton = (props: Props) => {
  const { isDisabled, label, onPress } = props;

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <GroupOrderBagButton isDisabled={isDisabled} onPress={onPress}>
      {label}
    </GroupOrderBagButton>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  isDisabled: boolean;
  label: string;
  onPress: () => void;
};
